export default {
    en: {
        LEVEL_SELECT_BADGE: {
            VACR: 'VIRGINIA CYBER RANGE',
            USCR: 'US CYBER RANGE'
        },
        LEVEL_SELECT_TITLE_MAIN: 'CyberSafe',
        LEVEL_SELECT_TITLE_ACCENT: 'AI',
        LEVEL_SELECT_OBJECTIVE: 'Jump to any mission and practice the skills you need. All missions are available to play in any order.',
        SCORE_BADGE_COMPLETE_LABEL: 'Completed',
        SCORE_BADGE_STAR_ALT: 'Current score: {score}',
    }
};
